import { createAction, props } from '@ngrx/store';
import { IClosePaymentRunRequest } from '../models/close-payment-run-request.model';
import { IClosePaymentRunResponse } from '../models/close-payment-run-response.model';

export const closePaymentRun = createAction(
  '[Payment Run] Close Payment Run',
  props<{
    request: IClosePaymentRunRequest;
  }>()
);

export const closePaymentRunSuccess = createAction(
  '[Payment Run] Close Payment Run Success',
  props<{ response: IClosePaymentRunResponse }>()
);

export const closePaymentRunFailure = createAction(
  '[Payment Run] Close Payment Run Failure',
  props<{ error: Error | any }>()
);
